<template>
  <div class="headers">
    <router-link tag="div" to="/index/remoteMonitor" class="h-logo">
      <!-- <div v-if="!jielu && showLogo" :class="{'h-l':organIdLogo == 1,'h-two':organIdLogo == 2, 'h-three':organIdLogo == 3 , 'h-four': organIdLogo == 4, 'h-five': organIdLogo == 5,'h-eight':organIdLogo==8,'h-nine':organIdLogo==9}"></div> -->
      <div
        v-if="!slecetName"
        class="logo-welcome"
        style="
          width: 200px;
          height: 100%;
          background-color: #ff6320;
          line-height: 38px;
        "
      >
        <img
          v-if="mainLogo"
          :src="mainLogo"
          style="width: 100%; height: 100%"
          alt=""
        />
        <img
          v-if="!mainLogo"
          :src="controlLogo"
          style="width: 119px; height: 40px"
          alt=""
        />
      </div>
      <div
        v-if="slecetName"
        class="logo-welcome"
        style="width: 240px; height: 100%; line-height: 38px"
      >
        <img
          v-if="slecetName"
          src="../assets/宁化县医院.png"
          style="width: 100%; height: 100%"
          alt=""
        />
      </div>
      <img v-if="!jielu && organIdLogo == 6" :src="welcomeLogo" alt="" />
      <img v-if="jielu" src="../assets/jielulogo.png" alt="" />
    </router-link>
    <div class="right-all">
      <div class="left-box">
        <!-- <div class="change-pattern">
                    <el-dropdown trigger="click" @command="handleCommand" class="dropA">
                        <span class="el-dropdown-link">
                            {{menuName}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="select-old">
                            <el-dropdown-item command="1">机构养老</el-dropdown-item>
                            <el-dropdown-item command="2">居家养老</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div> -->
        <!-- <el-button type="primary" size="mini" class="confirm-btn textBack" @click="changeMode">确认切换</el-button> -->
      </div>

      <div
        class="left-box text-colors"
        v-if="isMode != 99 || currentRole == 3 || currentRole == 4"
      >
        <!-- <span class="l-b-h">
                    {{ switchMode== 1 ? '机构养老' : '居家养老' }}
                </span> -->
      </div>
      <div class="right-box">
        <!--居家养老-->
        <!-- <div class="r-item r-warning" v-if="(isMode==99 && currentRole!=3 ) || (isMode==2 && switchMode==2)"> -->
        <div class="r-item">
          <el-popover
            placement="bottom"
            width="416"
            v-if="warning_enable == 1"
            @hide="warningHide"
            popper-class="popoverEl"
            trigger="hover"
          >
            <div>
              <div style="height: 460px; overflow: auto">
                <audio
                  v-if="isWarningPromptHome == 2 && sound_enable"
                  controls="controls"
                  autoplay="autoplay"
                  loop="loop"
                  id="audio"
                  style="display: none"
                >
                  <source src="../../static/4.mp3" type="audio/mpeg" />
                </audio>

                <div
                  class="r-warning-list"
                  v-for="item in messagesHome"
                  :key="item.id"
                >
                  <!-- v-if="![111,969,991,963,960,122].includes(item.Type)" -->
                  <div
                    class="r-warning-bot"
                    @click="jumpWarnPage(item.userId, item.pensionM, item)"
                  >
                    <div class="r-warning-item">
                      <div class="r-warning-icon"></div>
                      <div class="r-warning-info" v-if="item.terminal">
                        <span style="color: red">
                          {{
                            item.user.name
                              ? item.user.name + "用户"
                              : "设备" + item.device_no
                          }}
                        </span>
                        <span v-if="item.terminal.chip_code" style="color: red">
                          {{
                            item.terminal.mark
                              ? item.terminal.mark
                              : "智能居家紧急呼叫器"
                          }}
                        </span>
                        已出现
                        <span style="color: red">
                          {{
                            item.warning_type == 960
                              ? "测试报警"
                              : item.warning_type == 963
                              ? "拆除报警"
                              : item.warning_type == 969
                              ? "水浸报警"
                              : item.warning_type == 991
                              ? "燃气报警"
                              : item.warning_type == 111
                              ? "烟雾报警"
                              : item.warning_type == 121
                              ? "特殊提醒异常"
                              : item.warning_type == 123
                              ? "超出安全围栏"
                              : item.warning_type == 124
                              ? "疑似离家"
                              : item.warning_type == 125
                              ? "跌倒"
                              : item.warning_type == 127
                              ? "血压异常"
                              : item.warning_type == 128
                              ? "体温异常"
                              : item.warning_type == 129
                              ? "血氧异常"
                              : item.warning_type == 130
                              ? "运动心率异常"
                              : item.warning_type == 1
                              ? "心率异常"
                              : item.warning_type == 2
                              ? "呼吸异常"
                              : item.warning_type == 3
                              ? "离床异常"
                              : item.warning_type == 4
                              ? "设备异常"
                              : item.warning_type == 989
                              ? "开门报警"
                              : item.warning_type == 1988
                              ? "没关门报警"
                              : item.warning_type == 1989
                              ? "没开门报警"
                              : item.warning_type == 5
                              ? "褥疮风险预警"
                              : item.warning_type == 10
                              ? "重物预警"
                              : item.warning_type == 131
                              ? "佩戴异常"
                              : item.warning_type == 1991
                              ? "一氧化碳报警"
                              : item.warning_type == 938
                              ? "自检故障报警"
                              : item.warning_type == 986
                              ? "高温报警"
                              : item.warning_type == 1901
                              ? "低湿报警"
                              : item.warning_type == 1902
                              ? "高湿报警"
                              : item.warning_type == 1903
                              ? "低温报警"
                              : item.warning_type == 9901
                              ? "设备异常"
                              : item.warning_type == 384
                              ? "低电报警"
                              : item.warning_type == 2901
                              ? "无人报警"
                              : "紧急呼叫"
                          }}</span
                        >预警,请及时查看
                      </div>
                    </div>
                    <div class="time">{{ item.time_begin }}</div>
                  </div>
                  <!-- 新增烟感预警
                                    <div v-if="[111,969,991,963,960,122].includes(item.Type)" class="r-warning-bot" @click="jumpWarnPage(item.userId,item.pensionM)">
                                        <div class="r-warning-item">
                                            <div class="r-warning-icon"></div>
                                            <div class="r-warning-info">
                                                <span style="color:red;">{{item.site}} - {{item.name}}</span>
                                                房屋已出现 <span style="color:red;">{{
                                                    item.Type===111?'烟雾报警'
                                                    :item.Type===969?'水浸报警'
                                                    :item.Type===991?'燃气报警'
                                                    :item.Type===963?'拆除报警'
                                                    :item.Type===960?'测试报警'
                                                    :item.Type===122?'SOS紧急报警'
                                                    :'异常'
                                                }}
                                                </span>情况，请及时查看 ({{item.timeBegin}})
                                            </div>
                                        </div>
                                    </div> -->
                </div>
              </div>
              <div
                class="no-warning-list"
                style="cursor: pointer; line-height: 2px"
                v-if="warningNumHome"
                @click="readMore"
              >
                查看更多
              </div>
            </div>
            <!-- <el-badge slot="reference" :hidden="!warningNumHome" :value="warningNumHome" :max="99" class="item">
                            <div class="r-icon warning-icon" v-if="warningNumHome==0"></div>
                            <div class="r-icon warning-icon warining-icon-active" v-if="warningNumHome>0"></div>
                            <div class="r-warning-remend" @click="iconActive">居家预警</div>
                        </el-badge> -->
            <div slot="reference">
              <div
                @click="iconActive"
                :class="warningNumHome > 0 ? 'warning' : 'no-warning'"
                style="
                  width: 152px;
                  height: 36px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div class="left" style="line-height: 20px; margin-right: 3px">
                  <img
                    src="../assets/报警灯.png"
                    style="width: 18px; height: 18px"
                    alt=""
                  />
                </div>
                <div class="right" style="margin-right: 10px" v-if="slecetName">
                  待处理预警
                </div>
                <div class="right" style="margin-right: 10px" v-else>
                  居家预警
                </div>
                <div class="warn-num" v-if="warningNumHome > 0">
                  {{ warningNumHome }}
                </div>
              </div>
            </div>
          </el-popover>
        </div>

        <!--备忘录-->
        <div class="r-item r-memo">
          <el-popover
            placement="bottom"
            width="250"
            v-model="visible"
            :trigger="visible ? 'manual' : 'click'"
          >
            <div class="r-memo-mess">
              <div class="r-memo-title">备忘录</div>
              <div class="r-memo-list">
                <el-input
                  type="textarea"
                  :disabled="isDisabled"
                  class="textStyle"
                  :rows="13"
                  placeholder="请输入内容"
                  v-model="memoTextarea"
                >
                </el-input>
                <div class="r-memo-submit" slot="reference" @click="memorandum">
                  {{ amendOrSave }}
                </div>
              </div>
            </div>
            <div slot="reference" class="r-memo-badgeBox">
              <!-- <el-badge :value="10" hidden :max="99" class="item">
                                <div class="r-icon memo-icon"></div>
                            </el-badge>
                            <span class="r-txt">备忘录</span> -->
              <div
                class="don-forget"
                style="
                  width: 114px;
                  height: 36px;
                  background-color: #717071;
                  border: 1px solid #fff;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div class="left" style="line-height: 12px; margin-right: 3px">
                  <img
                    src="../assets/备忘录.png"
                    style="width: 14px; height: 16px"
                    alt=""
                  />
                </div>
                <div class="right">备忘录</div>
              </div>
            </div>
          </el-popover>
        </div>
        <!--消息-->
        <!--<div class="r-item r-message">-->
        <!--<el-badge :value="4" :max="99" class="item">-->
        <!--<div class="r-icon message-icon"></div>-->
        <!--</el-badge>-->
        <!--<span class="r-txt">消息</span>-->
        <!--</div>-->
        <!--登陆信息-->
        <div class="r-user">
          <div class="r-user-head"></div>
          <div class="r-user-name">{{ userName }} , 欢迎您 !</div>
          <div class="r-password-tap">
            <div
              class="r-p-list"
              style="margin-top: 5px; border-bottom: 1px solid #ccc"
              @click="openDialog"
            >
              <i style="font-size: 0.18rem" class="el-icon-news"></i>
              <span style="font-size: 0.15rem">修改密码</span>
            </div>
            <div class="r-p-list" style="margin-top: 0.04rem">
              <span style="font-size: 0.15rem">报警声音</span>
              <el-switch v-model="sound_enable" @change="soundEnable">
              </el-switch>
            </div>
          </div>
        </div>

        <!--退出登陆-->
        <div class="r-out" @click="loggedOut">退出登录</div>
      </div>
    </div>
    <el-dialog title="修改密码" :visible.sync="dialogTableVisible">
      <!-- <div class="l-o-j-tit">
                修改密码
            </div> -->
      <div class="l-o-j-content">
        <div class="l-box">
          <div class="contbox-default-content">
            <div class="c-d-c-tit">旧密码:</div>
            <el-input
              type="password"
              v-model="addVal.oldPW"
              placeholder=""
            ></el-input>
          </div>

          <div class="contbox-default-content">
            <div class="c-d-c-tit">新密码:</div>
            <el-input
              type="password"
              v-model="addVal.newPW"
              placeholder=""
            ></el-input>
          </div>

          <div class="contbox-default-content">
            <div class="c-d-c-tit">确认新密码:</div>
            <el-input
              type="password"
              v-model="addVal.surePW"
              placeholder=""
            ></el-input>
          </div>
        </div>
        <div class="l-o-j-submit" @click="closeDialog">完成</div>
      </div>
    </el-dialog>

    <!-- 新预警弹窗统一 -->
    <el-dialog
      :visible.sync="newInfoBoxShow"
      :title="newInfoBoxTitle"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name">
            <div v-if="newInfoBox.owner.name" class="u-i-left">用户姓名 :</div>
            <div v-if="newInfoBox.owner.name">
              {{ newInfoBox.owner.name }}
            </div>
          </div>

          <div class="user-i-name">
            <div v-if="newInfoBox.owner.mobile_phone" class="u-i-left">
              联系电话 :
            </div>
            <div v-if="newInfoBox.owner.mobile_phone">
              {{ newInfoBox.owner.mobile_phone }}
            </div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>

          <!-- <div class="user-i-name" v-if="newInfoBox.terminal">
            <div class="u-i-left">房间 :</div>
            <div>{{ newInfoBox.terminal.mark }}</div>
          </div> -->
          <div class="user-i-name">
            <div v-if="newInfoBox.imei" class="u-i-left">设备号 :</div>
            <div v-if="newInfoBox.imei">
              {{ newInfoBox.imei }}
            </div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">芯片码 :</div>
            <div>{{ ha07xTerminal.chip_code }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">设备类型:</div>
            <div>
              {{ ha07xTerminal.type }}
            </div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left">预警发生时间 :</div>
            <div style="width: 140px" v-if="newInfoBox.time_begin">
              {{ newInfoBox.time_begin }}
            </div>
            <div style="width: 140px" v-if="newInfoBox.timeBegin">
              {{ newInfoBox.timeBegin }}
            </div>
          </div>
          <div class="user-i-name" v-if="newInfoBox.address">
            <div class="u-i-left">预警发生位置 :</div>
            <div>{{ newInfoBox.address }}</div>
          </div>
          <div
            v-if="newInfoBox.address"
            id="locChat"
            style="width: 100%; height: 250px"
          ></div>

          <div class="new-save" @click="processing(5)">马上去处理</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="setRuleShow"
      title="体温异常预警提醒"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="temperatureInfo.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ temperatureInfo.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>
          <div class="user-i-name" v-if="temperatureInfo.owner.mobile_phone">
            <div class="u-i-left">联系电话 :</div>
            <div>{{ temperatureInfo.owner.mobile_phone }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name">
            <div
              class="u-i-left"
              style="width: 150px"
              v-if="temperatureInfo.owner.name"
            >
              用户姓名 :
            </div>
            <div
              style="width: 170px; text-align: left"
              v-if="temperatureInfo.owner.name"
            >
              {{ temperatureInfo.owner.name }}
            </div>
            <div class="u-i-left" v-if="temperatureInfo.owner.mobile_phone">
              联系电话 :
            </div>
            <div class="u-i-left" style="width: 150px" v-if="ownerData.age">
              用户年龄 :
            </div>
            <div style="width: 170px; text-align: left" v-if="ownerData.age">
              {{ ownerData.age }}
            </div>
            <div
              class="u-i-left"
              style="width: 150px"
              v-if="ownerData.emergency_contact_name"
            >
              紧急联系人姓名 :
            </div>
            <div
              style="width: 170px; text-align: left"
              v-if="ownerData.emergency_contact_name"
            >
              {{ ownerData.emergency_contact_name }}
            </div>
            <div
              class="u-i-left"
              style="width: 150px"
              v-if="ownerData.emergency_contact_phone"
            >
              紧急联系人电话 :
            </div>
            <div
              style="width: 170px; text-align: left"
              v-if="ownerData.emergency_contact_phone"
            >
              {{ ownerData.emergency_contact_phone }}
            </div>
            <div class="u-i-left">设备号 :</div>
            <div>
              {{ temperatureInfo.imei }}
            </div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div style="text-align: left">{{ temperatureInfo.time_begin }}</div>
            <div class="u-i-left" style="width: 150px">体温异常值 :</div>
            <div style="color: red">{{ temperatureInfo.temperature }}°C</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生位置 :</div>
            <div style="width: 350px; text-align: left">
              {{ temperatureInfo.address }}
            </div>
          </div>

          <div class="new-save" @click="processing(1)">马上去处理</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="setRuleShow2"
      title="疑似离家预警提醒"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name">
            <div
              class="u-i-left"
              style="width: 150px"
              v-if="suspectedToHomeInfo.owner.name"
            >
              用户姓名 :
            </div>
            <div v-if="suspectedToHomeInfo.owner.name">
              {{ suspectedToHomeInfo.owner.name }}
            </div>
          </div>
          <div class="user-i-name">
            <div
              v-if="suspectedToHomeInfo.owner.mobile_phone"
              class="u-i-left"
              style="width: 150px"
            >
              联系电话 :
            </div>
            <div style="width: 150px; text-align: left">
              {{ suspectedToHomeInfo.owner.mobile_phone }}
            </div>
            <div class="u-i-left" style="width: 150px" v-if="ownerData.age">
              用户年龄 :
            </div>
            <div style="width: 150px; text-align: left" v-if="ownerData.age">
              {{ ownerData.age }}
            </div>
          </div>

          <div class="user-i-name">
            <div
              class="u-i-left"
              style="width: 150px"
              v-if="ownerData.emergency_contact_name"
            >
              紧急联系人姓名 :
            </div>
            <div
              style="width: 150px; text-align: left"
              v-if="ownerData.emergency_contact_name"
            >
              {{ ownerData.emergency_contact_name }}
            </div>
            <div
              class="u-i-left"
              style="width: 150px"
              v-if="ownerData.emergency_contact_phone"
            >
              紧急联系人电话 :
            </div>
            <div
              style="width: 150px; text-align: left"
              v-if="ownerData.emergency_contact_phone"
            >
              {{ ownerData.emergency_contact_phone }}
            </div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left">设备号 :</div>
            <div>
              {{ suspectedToHomeInfo.imei }}
            </div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div style="width: 150px">{{ suspectedToHomeInfo.time_begin }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生位置 :</div>
            <div style="text-align: left">
              {{ suspectedToHomeInfo.address }}
            </div>
          </div>

          <div class="new-save" @click="processing(2)">马上去处理</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="setRuleShow3"
      title="血压异常预警提醒"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name">
            <div
              v-if="dysarteriotony.owner.name"
              class="u-i-left"
              style="width: 150px"
            >
              用户姓名 :
            </div>
            <div v-if="dysarteriotony.owner.name">
              {{ dysarteriotony.owner.name }}
            </div>
          </div>
          <div class="user-i-name">
            <div
              v-if="dysarteriotony.owner.mobile_phone"
              class="u-i-left"
              style="width: 150px"
            >
              联系电话 :
            </div>
            <div v-if="dysarteriotony.owner.mobile_phone">
              {{ dysarteriotony.owner.mobile_phone }}
            </div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px" v-if="ownerData.age">
              用户年龄 :
            </div>
            <div style="width: 150px; text-align: left" v-if="ownerData.age">
              {{ ownerData.age }}
            </div>
          </div>
          <div class="user-i-name">
            <div
              class="u-i-left"
              style="width: 150px"
              v-if="ownerData.emergency_contact_name"
            >
              紧急联系人姓名 :
            </div>
            <div
              style="width: 170px; text-align: left"
              v-if="ownerData.emergency_contact_name"
            >
              {{ ownerData.emergency_contact_name }}
            </div>
          </div>
          <div class="user-i-name">
            <div
              class="u-i-left"
              style="width: 150px"
              v-if="ownerData.emergency_contact_phone"
            >
              紧急联系人电话 :
            </div>
            <div
              style="width: 170px; text-align: left"
              v-if="ownerData.emergency_contact_phone"
            >
              {{ ownerData.emergency_contact_phone }}
            </div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left">设备号 :</div>
            <div>
              {{ dysarteriotony.imei }}
            </div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div style="width: 150px">{{ dysarteriotony.time_begin }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">收缩压 :</div>
            <div>{{ dysarteriotony.sbp }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">舒张压 :</div>
            <div>{{ dysarteriotony.dbp }}</div>
          </div>

          <div class="new-save" @click="processing(3)">马上去处理</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="setRuleShow4"
      title="心率异常预警提醒"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name">
            <div
              v-if="abnormalities.owner.name"
              class="u-i-left"
              style="width: 150px"
            >
              用户姓名 :
            </div>
            <div v-if="abnormalities.owner.name">
              {{ abnormalities.owner.name }}
            </div>
          </div>
          <div class="user-i-name">
            <div
              v-if="abnormalities.owner.mobile_phone"
              class="u-i-left"
              style="width: 150px"
            >
              联系电话 :
            </div>
            <div v-if="abnormalities.owner.mobile_phone">
              {{ abnormalities.owner.mobile_phone }}
            </div>
          </div>

          <div class="user-i-name">
            <div
              class="u-i-left"
              style="width: 150px"
              v-if="ownerData.emergency_contact_name"
            >
              紧急联系人姓名 :
            </div>
            <div
              style="width: 170px; text-align: left"
              v-if="ownerData.emergency_contact_name"
            >
              {{ ownerData.emergency_contact_name }}
            </div>
          </div>
          <div class="user-i-name">
            <div
              class="u-i-left"
              style="width: 150px"
              v-if="ownerData.emergency_contact_phone"
            >
              紧急联系人电话 :
            </div>
            <div
              style="width: 170px; text-align: left"
              v-if="ownerData.emergency_contact_phone"
            >
              {{ ownerData.emergency_contact_phone }}
            </div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">心率值 :</div>
            <div>{{ abnormalities.heartrate }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>
              {{ abnormalities.imei ? abnormalities.imei : abnormalities.mac }}
            </div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div style="width: 140px">{{ abnormalities.time_begin }}</div>
          </div>

          <div class="new-save" @click="processing(4)">马上去处理</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="setRuleShow5"
      title="SOS紧急呼叫预警提醒"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name">
            <div v-if="SOSemergency.owner.name" class="u-i-left">
              用户姓名 :
            </div>
            <div v-if="SOSemergency.owner.name">
              {{ SOSemergency.owner.name }}
            </div>
          </div>

          <div class="user-i-name">
            <div v-if="SOSemergency.owner.mobile_phone" class="u-i-left">
              联系电话 :
            </div>
            <div v-if="SOSemergency.owner.mobile_phone">
              {{ SOSemergency.owner.mobile_phone }}
            </div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>

          <!-- <div class="user-i-name" v-if="SOSemergency.terminal">
            <div class="u-i-left">房间 :</div>
            <div>{{ SOSemergency.terminal.mark }}</div>
          </div> -->
          <div class="user-i-name">
            <div class="u-i-left">设备号 :</div>
            <div>
              {{ SOSemergency.imei }}
            </div>
          </div>
          <!-- <div class="user-i-name" v-if="SOSemergency.chip_code">
            <div class="u-i-left" style="width: 150px">芯片码 :</div>
            <div>{{ ha07xTerminal.chip_code }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">设备类型:</div>
            <div>
              {{ ha07xTerminal.type}}
            </div>
          </div> -->
          <div class="user-i-name">
            <div class="u-i-left">预警发生时间 :</div>
            <div style="" v-if="SOSemergency.time_begin">
              {{ SOSemergency.time_begin }}
            </div>
            <div v-if="SOSemergency.timeBegin">
              {{ SOSemergency.timeBegin }}
            </div>
          </div>
          <div class="user-i-name" v-if="SOSemergency.type != 'HA07'">
            <div class="u-i-left">预警发生位置 :</div>
            <div>{{ SOSemergency.address }}</div>
          </div>
          <div id="locChat" style="width: 100%; height: 250px"></div>

          <div class="new-save" @click="processing(5)">马上去处理</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="setRuleShow6" title="跌倒预警提醒" width="666px">
      <!-- <div class="service-title">跌倒预警提醒</div> -->
      <div class="physical-check">
        <div class="order-data">
          <!-- <div class="user-i-name" v-if="fallWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ fallWarning.owner.name }}</div>
            <div class="u-i-left" style="width: 219px">联系电话 :</div>
            <div>{{ fallWarning.owner.mobile_phone }}</div>
          </div> -->
          <div class="user-i-name" v-if="fallWarning.owner.name">
            <div class="u-i-left">用户姓名 :</div>
            <div>{{ fallWarning.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="fallWarning.owner.name">
            <div class="u-i-left">联系电话 :</div>
            <div>{{ fallWarning.owner.mobile_phone }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ fallWarning.imei }}</div>
          </div>
          <di class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div style="width: 150px">{{ fallWarning.time_begin }}</div>
          </di>
          <div class="user-i-name">
            <div class="u-i-left">预警发生位置 :</div>
            <div style="width: 150px">{{ fallWarning.address }}</div>
          </div>

          <div class="new-save" @click="processing(6)">马上去处理</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="setRuleShow7"
      title="超出电子围栏预警提醒"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <!-- <div class="user-i-name" v-if="fenceWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ fenceWarning.owner.name }}</div>
            <div class="u-i-left" style="width: 219px">联系电话 :</div>
            <div>{{ fenceWarning.owner.mobile_phone }}</div>
          </div> -->
          <div class="user-i-name" v-if="fenceWarning.owner.name">
            <div class="u-i-left">用户姓名 :</div>
            <div>{{ fenceWarning.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="fenceWarning.owner.name">
            <div class="u-i-left">联系电话 :</div>
            <div>{{ fenceWarning.owner.mobile_phone }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left">设备号 :</div>
            <div>{{ fenceWarning.imei }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left">预警发生时间 :</div>
            <div style="width: 150px">{{ fenceWarning.time_begin }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left">预警发生位置 :</div>
            <div>{{ fenceWarning.address }}</div>
          </div>

          <div class="new-save" @click="processing(7)">马上去处理</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="setRuleShow8"
      title="特殊提醒异常预警提醒"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="SpecialRemindInfo.owner.name">
            <div class="u-i-left">用户姓名 :</div>
            <div>{{ SpecialRemindInfo.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="SpecialRemindInfo.owner.name">
            <div class="u-i-left">联系电话 :</div>
            <div>{{ SpecialRemindInfo.owner.mobile_phone }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name" v-if="!SpecialRemindInfo.owner.name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ SpecialRemindInfo.imei }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div style="width: 140px">{{ SpecialRemindInfo.time_begin }}</div>
            <div class="u-i-left">预警内容 :</div>
            <div style="color: red">{{ SpecialRemindInfo.content }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生位置 :</div>
            <div style="text-align: left">{{ SpecialRemindInfo.address }}</div>
          </div>

          <div class="new-save" @click="processing(8)">马上去处理</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="setRuleShow9" title="烟感报警提醒" width="666px">
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="NtwarningInfo.owner.name">
            <div class="u-i-left">用户姓名 :</div>
            <div>{{ NtwarningInfo.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="NtwarningInfo.owner.name">
            <div class="u-i-left">联系电话 :</div>
            <div>{{ NtwarningInfo.owner.mobile_phone }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备IMEI号:</div>
            <div style="">{{ NtwarningInfo.imei }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">芯片码 :</div>
            <div>{{ ha07xTerminal.chip_code }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">设备类型:</div>
            <div>
              {{ ha07xTerminal.type != "" ? "烟感报警器" : "烟感报警器" }}
            </div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left">预警发生时间 :</div>
            <div style="width: 140px" v-if="NtwarningInfo.time_begin">
              {{ NtwarningInfo.time_begin }}
            </div>
            <div style="width: 140px" v-if="NtwarningInfo.timeBegin">
              {{ NtwarningInfo.timeBegin }}
            </div>
          </div>
          <!-- <div class="user-i-name">
            <div class="u-i-left" style="">预警内容 :</div>
            <div style="color: red">{{ NtwarningInfo.alarmDesc }}</div>
          </div> -->
          <div class="new-save" @click="processing(9)">马上去处理</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="setRuleShow10"
      title="运动心率预警提醒"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="EXSwarningInfo.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ EXSwarningInfo.owner.name }}</div>
            <div class="u-i-left">联系电话 :</div>
            <div>{{ EXSwarningInfo.owner.mobile_phone }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name" v-if="!EXSwarningInfo.owner.name">
            <div class="u-i-left" style="width: 150px">设备IMEI号:</div>
            <div style="width: 170px">{{ EXSwarningInfo.imei }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div style="width: 140px">{{ EXSwarningInfo.time_begin }}</div>
          </div>
          <div class="new-save" @click="processing(10)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="setRuleShow11" title="离床预警提醒" width="666px">
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="outBedWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ outBedWarning.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div>{{ outBedWarning.time_begin }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">睡眠带物理地址 :</div>
            <div>{{ outBedWarning.mac }}</div>
          </div>

          <div class="new-save" @click="processing(11)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="setRuleShow12"
      title="血氧异常预警提醒"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="bloodOxygenWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ bloodOxygenWarning.owner.name }}</div>
            <div class="u-i-left">联系电话 :</div>
            <div>{{ bloodOxygenWarning.owner.mobile_phone }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name" v-if="!bloodOxygenWarning.owner.name">
            <div class="u-i-left" style="width: 150px">设备IMEI号:</div>
            <div style="width: 170px">{{ bloodOxygenWarning.imei }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div>{{ bloodOxygenWarning.time_begin }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">血氧百分比 :</div>
            <div>{{ bloodOxygenWarning.bloodoxygen }}</div>
          </div>

          <div class="new-save" @click="processing(12)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="setRuleShow13" title="拆除预警提醒" width="666px">
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="dismaWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ dismaWarning.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ dismaWarning.imei }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div>{{ dismaWarning.timeBegin }}</div>
          </div>
          <div class="new-save" @click="processing(13)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="setRuleShow14" title="开门预警提醒" width="666px">
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="openWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ openWarning.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ openWarning.imei }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">芯片码 :</div>
            <div>{{ ha07xTerminal.chip_code }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">设备类型:</div>
            <div>
              {{ ha07xTerminal.type != "" ? "门磁报警器" : "门磁报警器" }}
            </div>
          </div>

          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div>{{ openWarning.timeBegin }}</div>
          </div>
          <div class="new-save" @click="processing(14)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="setRuleShow15" title="燃气预警提醒" width="666px">
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="gasWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ gasWarning.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ gasWarning.imei }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">芯片码 :</div>
            <div>{{ ha07xTerminal.chip_code }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">设备类型:</div>
            <div>
              {{ ha07xTerminal.type != "" ? "燃气报警器" : "燃气报警器" }}
            </div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left">预警发生时间 :</div>
            <div style="width: 140px" v-if="gasWarning.time_begin">
              {{ gasWarning.time_begin }}
            </div>
            <div style="width: 140px" v-if="gasWarning.timeBegin">
              {{ gasWarning.timeBegin }}
            </div>
          </div>
          <div class="new-save" @click="processing(15)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="setRuleShow16" title="水浸预警提醒" width="666px">
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="waterWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ waterWarning.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ waterWarning.imei }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">芯片码 :</div>
            <div>{{ ha07xTerminal.chip_code }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">设备类型:</div>
            <div>
              {{ ha07xTerminal.type != "" ? "水浸报警器" : "水浸报警器" }}
            </div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div>{{ waterWarning.timeBegin }}</div>
          </div>
          <div class="new-save" @click="processing(16)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="setRuleShow17" title="呼吸异常提醒" width="666px">
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="breathWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ breathWarning.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ breathWarning.imei }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div v-if="breathWarning.time_begin">
              {{ breathWarning.time_begin }}
            </div>
            <div v-if="breathWarning.timeBegin">
              {{ breathWarning.timeBegin }}
            </div>
          </div>
          <div class="new-save" @click="processing(17)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="setRuleShow18"
      title="设备异常提醒(睡眠带)"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="EquipmentAbnormal.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ EquipmentAbnormal.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>
              {{
                EquipmentAbnormal.imei
                  ? EquipmentAbnormal.imei
                  : EquipmentAbnormal.mac
              }}
            </div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div v-if="EquipmentAbnormal.time_begin">
              {{ EquipmentAbnormal.time_begin }}
            </div>
            <div v-if="EquipmentAbnormal.timeBegin">
              {{ EquipmentAbnormal.timeBegin }}
            </div>
          </div>
          <div class="new-save" @click="processing(18)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="setRuleShow19" title="佩戴异常提醒" width="666px">
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="wearAbnormal.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ wearAbnormal.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ wearAbnormal.imei }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div v-if="wearAbnormal.time_begin">
              {{ wearAbnormal.time_begin }}
            </div>
            <div v-if="wearAbnormal.timeBegin">
              {{ wearAbnormal.timeBegin }}
            </div>
          </div>
          <div class="new-save" @click="processing(19)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="setRuleShow20" title="重物预警提醒" width="666px">
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="outBedWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ outBedWarning.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div>{{ outBedWarning.time_begin }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">睡眠带物理地址 :</div>
            <div>{{ outBedWarning.mac }}</div>
          </div>

          <div class="new-save" @click="processing(11)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="setRuleShow21"
      title="一氧化碳预警提醒"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="coOneWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ coOneWarning.owner.name }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ coOneWarning.imei }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div>{{ coOneWarning.timeBegin }}</div>
          </div>
          <div class="new-save" @click="processing(15)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="setRuleShow22" title="高温预警提醒" width="666px">
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="HTeWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ HTeWarning.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ HTeWarning.imei }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div>{{ HTeWarning.timeBegin }}</div>
          </div>
          <div class="new-save" @click="processing(15)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="setRuleShow23" title="低温预警提醒" width="666px">
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="LTeWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ LTeWarning.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ LTeWarning.imei }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div>{{ LTeWarning.timeBegin }}</div>
          </div>
          <div class="new-save" @click="processing(15)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="setRuleShow24" title="高湿预警提醒" width="666px">
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="HHUWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ HHUWarning.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ HHUWarning.imei }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div>{{ HHUWarning.timeBegin }}</div>
          </div>
          <div class="new-save" @click="processing(15)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="setRuleShow25" title="低湿预警提醒" width="666px">
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="LHUWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ LHUWarning.owner.name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ LHUWarning.imei }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div>{{ LHUWarning.timeBegin }}</div>
          </div>
          <div class="new-save" @click="processing(15)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="setRuleShow26"
      title="自检故障预警提醒"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="CHECKWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ CHECKWarning.owner.name }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ CHECKWarning.imei }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div>{{ CHECKWarning.timeBegin }}</div>
          </div>
          <div class="new-save" @click="processing(15)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="setRuleShow27"
      title="设备异常(433终端)"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ HeartBeaWarning.owner.name }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ HeartBeaWarning.imei }}</div>
          </div>

          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">芯片码 :</div>
            <div>{{ ha07xTerminal.chip_code }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">设备类型:</div>
            <div>{{ ha07xTerminal.type }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div v-if="HeartBeaWarning.time_begin">
              {{ HeartBeaWarning.time_begin }}
            </div>
            <div v-if="HeartBeaWarning.timeBegin">
              {{ HeartBeaWarning.timeBegin }}
            </div>
          </div>
          <div class="new-save" @click="processing(18)">马上去处理</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="setRuleShow28" title="低电预警提醒" width="666px">
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="LowPowerWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ LowPowerWarning.owner.name }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ LowPowerWarning.imei }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">芯片码 :</div>
            <div>{{ ha07xTerminal.chip_code }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">设备类型:</div>
            <div>{{ ha07xTerminal.type }}</div>
            <!-- <div>{{ ha07xTerminal.type !=""?'红外报警器':'红外报警器' }}</div> -->
          </div>
          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div v-if="LowPowerWarning.time_begin">
              {{ LowPowerWarning.time_begin }}
            </div>
            <div v-if="LowPowerWarning.timeBegin">
              {{ LowPowerWarning.timeBegin }}
            </div>
          </div>
          <div class="new-save" @click="processing(18)">马上去处理</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="setRuleShow29"
      title="没开门预警提醒"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="NOopenWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ NOopenWarning.owner.name }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ NOopenWarning.imei }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">芯片码 :</div>
            <div>{{ ha07xTerminal.chip_code }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">设备类型:</div>
            <div>
              {{ ha07xTerminal.type != "" ? "门磁报警器" : "门磁报警器" }}
            </div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>

          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div>{{ NOopenWarning.timeBegin }}</div>
          </div>
          <div class="new-save" @click="processing(14)">马上去处理</div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="setRuleShow30"
      title="没关门预警提醒"
      width="666px"
    >
      <div class="physical-check">
        <div class="order-data">
          <div class="user-i-name" v-if="NOinsWarning.owner.name">
            <div class="u-i-left" style="width: 150px">用户姓名 :</div>
            <div>{{ NOinsWarning.owner.name }}</div>
          </div>

          <div class="user-i-name" v-if="ownerData.age">
            <div class="u-i-left">用户年龄 :</div>
            <div>{{ ownerData.age }}</div>
          </div>
          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">设备号 :</div>
            <div>{{ NOinsWarning.imei }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">芯片码 :</div>
            <div>{{ ha07xTerminal.chip_code }}</div>
          </div>
          <div class="user-i-name" v-if="ha07xTerminal.chip_code">
            <div class="u-i-left" style="width: 150px">设备类型:</div>
            <div>
              {{ ha07xTerminal.type != "" ? "门磁报警器" : "门磁报警器" }}
            </div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_name">
            <div class="u-i-left">紧急联系人姓名 :</div>
            <div>{{ ownerData.emergency_contact_name }}</div>
          </div>
          <div class="user-i-name" v-if="ownerData.emergency_contact_phone">
            <div class="u-i-left">紧急联系人电话 :</div>
            <div>{{ ownerData.emergency_contact_phone }}</div>
          </div>

          <div class="user-i-name">
            <div class="u-i-left" style="width: 150px">预警发生时间 :</div>
            <div>{{ NOinsWarning.timeBegin }}</div>
          </div>
          <div class="new-save" @click="processing(14)">马上去处理</div>
        </div>
      </div>
    </el-dialog>

    <!-- <el-dialog
      :visible.sync="setRuleShow30"
      title="当前网络不可用,请检查您的网络是否正常?"
      width="666px"
    >
      <div class="new-save" @click="processing(14)">马上去处理</div>
    </el-dialog> -->
    <el-dialog title="提示" :visible.sync="dialogVisibleOnLine" width="20%">
      <div class="physical-check">
        <div class="order-data">
          <span>当前网络不可用,请检查您的网络是否正常?</span>
          <div class="new-save" @click="processOnLine">刷新</div>
          <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleOnLine = false"
          >确 定</el-button
        >
      </span> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ws_URL, get, post, ws_URLOne } from "../libs/tool";
import bus from "../libs/bus";
import aiqiangualogo from "../assets/left-logo.png";
// import bus from "./eventBus"
import {
  api_editPassword,
  api_listSleepBandWarning,
  api_listToDoList,
  api_addMemorandum,
  api_getMemorandum,
  api_completeToDoList,
  api_timingGetToDo,
  api_NotDisposed,
  api_listWarningNotice,
  api_setPensionMode,
  setSoundEnable,
  api_logout,
} from "../api/api";
export default {
  name: "headers",
  inject: ["reload"],
  data() {
    return {
      dialogVisibleOnLine: false,
      controlLogo: aiqiangualogo,
      menuTitle: "",
      mainLogo: "",
      oemHome: "",
      SendData: "",
      msg: "头部组件",
      fullpage: false,
      memoTextarea: "",
      remendTotal: "0",
      dialogTableVisible: false,
      visible: false,
      backlogRemind: [],
      messages: [], //机构养老
      messagesHome: [], //居家养老
      isWarningPrompt: 1, //机构养老
      isWarningPromptHome: 1, //居家养老
      sound_enable: true,
      userName: "",
      isDisabled: true,
      amendOrSave: "修改",
      addVal: {
        oldPW: "",
        newPW: "",
        surePW: "",
      },
      closeStatus: false,
      everyTimeOuter: "",
      currentLoginId: "",

      serverMessage: "I am OK",
      warningNum: 0, // 机构
      warningNumHome: 0, //居家
      helpInformation: {},
      helpInformations: [],

      organIdLogo: "",

      showLogo: true, //根据机构确定是否显示logo,

      // 切换模式
      switchMode: "",

      menuName: "机构养老",

      currentRole: 0,

      isMode: "", //判断模式  1：机构   2：居家  99：两者都有
      //设置oem图片
      welcomeLogo: "",
      jielu: false, //jielu公司logo图片

      newInfoBoxShow: false, //统一报警弹窗
      newInfoBoxTitle: "出现预警",
      newInfoBox: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        address: "",
      }, //统一报警弹窗信息

      setRuleShow: false, //体温
      setRuleShow2: false, //在离家
      setRuleShow3: false, //血压
      setRuleShow4: false, //心率
      setRuleShow5: false, //sos
      setRuleShow6: false, //跌倒
      setRuleShow7: false, //电子围栏
      setRuleShow8: false, //特殊提醒
      setRuleShow9: false, //烟感提醒
      setRuleShow10: false, //运动心率
      setRuleShow11: false, //离床预警
      setRuleShow12: false, //血氧预警
      setRuleShow13: false, //拆除预警
      setRuleShow14: false, //开门预警
      setRuleShow15: false, //燃气预警
      setRuleShow16: false, //水浸预警
      setRuleShow17: false, //呼吸预警
      setRuleShow18: false, //设备异常
      setRuleShow19: false, //佩戴异常
      setRuleShow20: false, //重物预警
      setRuleShow21: false, //一氧化碳预警
      setRuleShow22: false, //高温
      setRuleShow23: false, //低温
      setRuleShow24: false, //高湿
      setRuleShow25: false, //低湿
      setRuleShow26: false, //自检
      setRuleShow27: false, //设备异常(居家)
      setRuleShow28: false, //低电报警
      setRuleShow29: false, //没开门预警
      setRuleShow30: false, //没关门预警
      // 异常预警警报
      abnormalUser: "", //用户名
      phoneNum: "", //联系电话
      abnormalTime: "", //发生时间
      abnormalTemperature: "", //异常体温值
      abnormalLocation: "", //发生位置
      //佩戴异常的弹窗
      wearAbnormal: {
        owner: {
          name: "",
        },
        time_begin: "",
      },
      //设备异常的弹窗
      EquipmentAbnormal: {
        owner: {
          name: "",
        },
        time_begin: "",
      },
      //体温异常预警弹窗的信息
      temperatureInfo: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        temperature: "",
        address: "",
      },
      // 在离家弹窗信息
      suspectedToHomeInfo: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        address: "",
      },
      // 血压异常弹窗信息
      dysarteriotony: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        sbp: "",
        dbp: "",
      },
      // 心率异常弹窗信息
      abnormalities: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        heartrate: "",
      },
      // sos弹窗信息
      SOSemergency: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        address: "",
        terminal: {},
      },
      // 跌倒
      fallWarning: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        address: "",
      },
      // 电子围栏
      fenceWarning: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        address: "",
      },
      //特殊提醒异常预警弹窗的信息
      SpecialRemindInfo: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        content: "",
        time_begin: "",
        alertText: "",
        address: "",
      },
      //烟感预警弹窗的信息
      NtwarningInfo: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        imei: "",
        timeBegin: "",
        alarmDesc: "",
      },
      // 运动心率
      EXSwarningInfo: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        address: "",
      },
      // 离床
      outBedWarning: {
        owner: {
          name: "",
        },
        time_begin: "",
        mac: "",
      },
      //血氧异常
      bloodOxygenWarning: {
        owner: {
          name: "",
          mobile_phone: "",
        },
        time_begin: "",
        bloodoxygen: "",
      },
      // 拆除报警
      dismaWarning: {
        owner: {
          name: "",
        },
        timeBegin: "",
      },
      // 呼吸
      breathWarning: {
        owner: {
          name: "",
        },
        timeBegin: "",
      },
      // 开门报警
      openWarning: {
        owner: {
          name: "",
        },
        timeBegin: "",
      },
      // 没开门报警
      NOopenWarning: {
        owner: {
          name: "",
        },
        timeBegin: "",
      },
      // 没关门报警
      NOinsWarning: {
        owner: {
          name: "",
        },
        timeBegin: "",
      },
      // 燃气报警
      gasWarning: {
        owner: {
          name: "",
        },
        timeBegin: "",
      },
      //水浸报警
      waterWarning: {
        owner: {
          name: "",
        },
        timeBegin: "",
      },
      //一氧化碳报警
      coOneWarning: {
        owner: {
          name: "",
        },
        timeBegin: "",
      },
      //高温报警
      HTeWarning: {
        owner: {
          name: "",
        },
        timeBegin: "",
      },
      //低温报警
      LTeWarning: {
        owner: {
          name: "",
        },
        timeBegin: "",
      },
      //高湿报警
      HHUWarning: {
        owner: {
          name: "",
        },
        timeBegin: "",
      },
      //低湿报警
      LHUWarning: {
        owner: {
          name: "",
        },
        timeBegin: "",
      },
      //自检报警
      CHECKWarning: {
        owner: {
          name: "",
        },
        timeBegin: "",
      },
      //设备异常(居家)报警
      HeartBeaWarning: {
        owner: {
          name: "",
        },
        timeBegin: "",
      },
      //低电预警
      LowPowerWarning: {
        owner: {
          name: "",
        },
        timeBegin: "",
      },
      ha07xTerminal: {},
      warning_enable: "",
      mapObj: null,
      slecetName: "",
      ownerData: {}, //绑定人信息与紧急联系人,
      network: true,
    };
  },
  created() {
    if (this.$route) {
      console.log(this.$route.path);
    }
    let companyName = sessionStorage.getItem("companyName");
    if (companyName == "智能看护系统") {
      this.jielu = true;
    }
    console.log(this.messagesHome);
    // let auth = localStorage.getItem("item");
    // auth = typeof auth == "string" ? JSON.parse(auth) : auth;
    // this.auth = auth;
    let auth = localStorage.getItem("auth");
    this.auth = typeof auth == "string" ? JSON.parse(auth) : auth;
    console.log(this.auth.sound_enable, "this.auth.role.sound_enable");
    this.sound_enable = this.auth.sound_enable == 1 ? true : false;
    if (this.auth.organization.tag == "ninghua") {
      this.slecetName = "人员";
    } else {
      this.slecetName = "";
    }
    this.warning_enable = this.auth.role.warning_enable;
    let arganId = this.auth.organization.id;
    this.switchMode = localStorage.getItem("toggleM"); //获取登录并转化成字符串
    this.menuName = this.switchMode == 2 ? "居家养老" : "机构养老";

    // console.log("arganId", arganId);
    this.organIdLogo =
      arganId == "000000006a34fd5a016a85dd2c920001"
        ? 2
        : arganId == "000000006a90191f016af76f93c608ca"
        ? 0
        : arganId == "000000006a90191f016ab5360a3e0398"
        ? 3
        : arganId == "000000006a90191f016abe872bea04d7"
        ? 4
        : arganId == "000000006c9515d5016da914805d0a93"
        ? 5
        : arganId == "0000000070ae249601712e9deedf00b5"
        ? 6
        : arganId == "0000000072f21ef4017303b86f0e000a"
        ? 8
        : arganId == "00000000735c100401735c1802b70001"
        ? 9
        : 1;
    // console.log("organIdLogo", this.organIdLogo);
    this.showLogo = !(
      arganId == "000000006b6d88bc016c4ac8f22914bf" ||
      arganId == "000000006e90c1f7016ea5a5d95600c2"
    );

    //根据登录判断切换

    this.currentRole = JSON.parse(localStorage.getItem("auth")).role.role_type;

    this.isMode = JSON.parse(
      localStorage.getItem("auth")
    ).organization.allow_pension_mode;
  },
  mounted() {
    let that = this;
    // console.log("根据登录判断切换", this.currentRole);
    this.oemHome = JSON.parse(localStorage.getItem("oem-home"));
    console.log(this.oemHome);
    if (this.oemHome) {
      this.mainLogo = this.oemHome.main_logo;
      this.menuTitle = this.oemHome.menu_title;
      console.log(this.mainLogo);
    }
    // console.log("showLogo", this.showLogo);
    this.$nextTick(() => {
      this.socketInit();
    });
    window.addEventListener("offline", () => {
      // this.network = false;
      // this.socketInit();
      console.log("没网");
      this.dialogVisibleOnLine = true;
    });
    window.addEventListener("online", () => {
      console.log("有网");
      // this.network = true;
      this.dialogVisibleOnLine = false;
    });

    // this.socketInitOne() ;

    // console.log("根据登录判断切换", this.isMode, this.currentRole);

    // this.headDetails();
    this.getHomeOld();

    // this.toRemind();

    this.readMemo();

    this.userName = localStorage.getItem("userName");
    //      setInterval(() => {
    //        console.log(123456)
    //        this.selfMotionRemeind() ;
    //      },60000)

    if (that.socket) {
      if (that.socket.readyState == 1) {
        this.everyTime();
      }
    }
    bus.$on("dealWarningP", function (value) {
      console.log("我处理好了，重新刷接口", value);
      if (value == 1) {
        that.headDetails();
      } else {
        that.getHomeOld();
      }
    });
    bus.$on("clearWarn", (dat) => {
      console.log(dat);
      if (dat) {
        this.getHomeOld();
      }
    });
    this.$nextTick(function () {
      // console.log(sessionStorage.getItem("companyOem"));
      that.welcomeLogo = sessionStorage.getItem("companyOem")
        ? JSON.parse(sessionStorage.getItem("companyOem")).welcome_logo
        : "";
      // console.log("oem设置", this.welcomeLogo);
    });
  },
  methods: {
    soundEnable() {
      console.log(this.sound_enable);
      let data = {
        enable: this.sound_enable ? 1 : 0,
      };
      post(setSoundEnable, data, (res) => {
        if (res.success) {
          console.log(res, "ggggg");
          // JSON.parse(localStorage.setItem("auth")).sound_enable = this.sound_enable?1:0
          // 从本地存储中获取 JSON 字符串
          var jsonString = localStorage.getItem("auth");

          // 将 JSON 字符串解析为 JavaScript 对象
          var authObject = JSON.parse(jsonString);

          // 修改对象属性
          authObject.sound_enable = this.sound_enable ? 1 : 0;

          // 将修改后的对象转换为 JSON 字符串
          var modifiedJsonString = JSON.stringify(authObject);

          // 将修改后的 JSON 字符串保存到本地存储中
          localStorage.setItem("auth", modifiedJsonString);
        }
      });
    },
    processOnLine() {
      this.dialogVisibleOnLine = false;
      this.socketInit();
      // location.reload()
    },
    //初始化地图对象，加载地图
    getShowMap(data) {
      let that = this;
      this.$nextTick(() => {
        if (data) {
          // that.initMap4(data);
         that.initMap3(data.lon, data.lat);
          var url =
            "http://php.aiqiangua.com/NewSmartCare/fore-end_images/sos报警.png";

          that.addMarker3(
            data.lon,
            data.lat,
            url,
            data.address,
            data.time_begin,
            data.imei,
            data.user_name,
            data.user_phone
          );
        } else {
          that.initMap3(116.397428, 39.90923); 
          // that.initMap4(116.397428, 39.90923); //没有定位数据时，默认以北京天安门为地图中心坐标
        }
      });
    },
    initMap4(data) {
      const map = new aimap.Map({
        container: "locChat",
        zoom: 15,
        center: [data.lon, data.lat],
        minZoom: 3,
        maxZoom: 20,
        pitch: 0,
        bearing: 0,
        style: "aimap://styles/aimap/white-21Q4-v1",
        localIdeographFontFamily: "'Microsoft YaHei'",
      });
       map.addImage(
        "dataSOSImg",
        "http://php.aiqiangua.com/NewSmartCare/fore-end_images/sos报警.png"
      );
      let mapMark = []
      mapMark.push({
            id: 1,
            icon: "dataSOSImg",
            coordinates: [data.lon, data.lat],
            ...data,
          });
          this.createOrUpdateMassMarkerLayer(map,mapMark)
    //   const marker1 = new aimap.Marker()
    // .setLngLat([lng, lat])
    // .addTo(map);
    

    },
    createOrUpdateMassMarkerLayer(map, mapMark) {
      console.log(map, mapMark, "map, mapMarkmap, mapMark");
      // 如果MassMarkerLayer已存在，则更新数据
      let MassMarkerLayer;
      map.on("load", () => {
        // 创建海量点图层
        MassMarkerLayer = new aimap.MassMarkerLayer({
          map,
          data: mapMark,
          id: "projectLayer",
          zIndex: "99",
          style: {
            // 样式配置...
            // 'text-field': '{name}',
            "text-color": "#00ff00",
            // "text-anchor": "bottom",

            "icon-anchor": "top",
            "icon-image": ["get", "icon"], // 获取data中的icon属性值来配置图标
            "icon-size": .8,
            "icon-allow-overlap": true,
            "icon-keep-upright": true, // 设置图标始终保持笔直
          },
        });
        // 设置弹窗
        MassMarkerLayer.on("click", (e) => {
          // 说明当前的弹出框是开启状态
          console.log(
            e,
            "MassMarkerLayerMassMarkerLayerMassMarkerLayerMassMarkerLayer"
          );
          if (
            MassMarkerLayer.getPopup() &&
            MassMarkerLayer.getPopup().isOpen()
          ) {
            return;
          }

          //   data.address,
          //   data.time_begin,
          //   data.imei,
          //   data.user_name,
          //   data.user_phone

          const { properties } = e.features[0];
          console.log(properties, "properties");
          const popupHtml =
          `<div class="popuoHtml" style='font-size: 12px;text-align: left;'>
                             <div>用户: ` +
            (properties.user_name ? properties.user_name : "- -") +
            `</div>
                            <div>IMEI: ` +
            (properties.imei ? properties.imei : "- -") +
            `</div>
                            <div>手机号: ` +
            (properties.user_phone ? properties.user_phone : "- -") +
            `</div>
                ` +
            (properties.address 
              ? properties.address 
             
              : "- -") +
            `<div>时间: ` +
            (properties.time_begin ? properties.time_begin : "- -") +
            `</div>
                </div>`;

          MassMarkerLayer.setPopup(popupHtml, {
            offset: 1,
            maxWidth: "320px",
            // className: "ditiezhan",
          });
          MassMarkerLayer.getPopup().setLngLat(
            e.features[0].geometry.coordinates
          ); // 点图层时的方法
          MassMarkerLayer.togglePopup();
        });
      });
    },
    initMap3(lng, lat) {
      this.mapObj = new AMap.Map("locChat", {
        resizeEnable: true,
        //二维地图显示视口
        //设定地图中心点
        //设置地图显示的缩放级别
        view: new AMap.View2D({
          center: new AMap.LngLat(lng, lat),
          zoom: 13,
        }),
      });
      console.log(this.mapObj, 1063);
    },
    addMarker3(lng, lat, url, title, time, imei, nickname, tel) {
      let that = this;
      var intpx = 48;
      var marker = new AMap.Marker({
        icon: new AMap.Icon({
          //复杂图标
          size: new AMap.Size(intpx, intpx), //图标大小
          image: url, //大图地址
          //    imageOffset:new AMap.Pixel(-28,0)//相对于大图的取图位置
        }),
        position: new AMap.LngLat(lng, lat),
      });
      var info = [];
      console.log(marker, 1078);
      info.push("用户: " + nickname);
      info.push("手机号: " + tel);
      info.push("IMEI: " + imei);
      //  info.push("昵称: " + nickname);
      info.push(time);
      info.push(title);

      var inforWindow = new AMap.InfoWindow({
        position: new AMap.LngLat(lng, lat),
        offset: new AMap.Pixel(10, -23),
        content: info.join("<br>"),
      });
      AMap.event.addListener(marker, "click", function (e) {
        inforWindow.open(that.mapObj, marker.getPosition());
      });
      marker.setMap(that.mapObj); //在地图上添加点
      marker.setTitle(title);
    },
    loggedOut() {
      let data = {
        employee_id: this.auth.id,
      };
      post(api_logout, data, (res) => {
        console.log("退出登录", res);
        localStorage.removeItem("adminToken");

        if (this.oemHome) {
          this.$router.push({
            name: "login",
            query: {
              tag: this.oemHome.tag,
            },
          });
          console.log(this.oemHome, 1129);
          localStorage.removeItem("oem-home");
          return;
        }
        localStorage.removeItem("adminToken");

        console.log("点击了退出登录");
        let gid =
          this.auth.organization.id == "000000006e90c1f7016ea5a5d95600c2"
            ? "huiming"
            : this.auth.organization.id == "0000000072f21ef4017303b86f0e000a"
            ? "jianggou"
            : this.auth.organization.id == "00000000735c100401735c1802b70001"
            ? "hualing"
            : "";
        // localStorage.removeItem('auth')

        // 是否为jielu平台
        if (!this.jielu) {
          // alert('不是jielu平台')
          sessionStorage.removeItem("companyName");
          this.$router.push({
            name: "login",
            query: {
              gid: gid,
            },
          });
        } else {
          // alert('是jielu平台')
          sessionStorage.removeItem("companyName");
          this.$router.push({
            name: "login",
            query: {
              gid: "jielu",
            },
          });
        }
      });
    },
    processing(num) {
      this.setRuleShow = false;
      this.setRuleShow2 = false;
      this.setRuleShow3 = false;
      this.setRuleShow4 = false;
      this.setRuleShow5 = false;
      this.setRuleShow6 = false;
      this.setRuleShow7 = false;
      this.setRuleShow8 = false;
      this.setRuleShow9 = false;
      this.setRuleShow10 = false;
      this.setRuleShow11 = false;
      this.setRuleShow12 = false;
      this.setRuleShow13 = false;
      this.setRuleShow14 = false;
      this.setRuleShow15 = false;
      this.setRuleShow16 = false;
      this.setRuleShow17 = false;
      this.setRuleShow18 = false;
      this.setRuleShow19 = false;
      this.setRuleShow20 = false; //重物
      this.setRuleShow21 = false; //一氧化碳
      this.setRuleShow22 = false; //高温
      this.setRuleShow23 = false; //低温
      this.setRuleShow24 = false; //高湿
      this.setRuleShow25 = false; //高湿
      this.setRuleShow26 = false; //高湿
      this.setRuleShow27 = false; //高湿
      this.setRuleShow28 = false; //高湿
      this.setRuleShow29 = false; //高湿
      this.setRuleShow30 = false; //高湿
      this.ha07xTerminal = {};

      this.newInfoBoxShow = false;
      this.$router.push("/index/warningDeal");
    },
    readMore() {
      console.log("预警处理查看更多");
      this.$router.push("/index/warningDeal");
    },
    fullSc() {
      if (!this.fullpage) {
        if (document.documentElement.requestFullscreencreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) {
          document.documentElement.webkitRequestFullScreen();
        } else if (document.documentElement.msRequestFullScreen) {
          document.documentElement.msRequestFullScreen();
        }
        this.fullpage = true;
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
        this.fullpage = false;
      }
      console.log(this.fullpage);
    },

    closeDialog() {
      this.dialogTableVisible = false;

      let that = this;

      let date = {
        organ_id: that.auth.organization.id,
        operator_id: that.auth.id,
        old_password: that.addVal.oldPW,
        new_password: that.addVal.newPW,
        new_password_again: that.addVal.surePW,
      };

      post(api_editPassword, date, function (res) {
        if (res.success) {
          that.$message({
            type: "success",

            message: "修改成功",
          });
        } else {
          that.$message({
            type: "info",

            message: "删除失败：" + res.error_desc,
          });
        }
      });
    },
    openDialog() {
      this.dialogTableVisible = true;
    },
    iconActive() {
      console.log("我已经点击了2323232");
      // this.isWarningPrompt = 1 ;
    },
    jumpWarnPage(userId, pensionM, user) {
      console.log("点击跳转", userId, pensionM, this.switchMode);

      // if (this.switchMode != pensionM) {
      //     this.switchMode = pensionM;
      //     this.menuName = this.switchMode == 2 ? "居家养老" : "机构养老";
      //     this.changeMode();
      // }

      this.$router.push({
        name: "warningDeal",
        query: {
          userID: userId,
          warning_id: user.id,
          warning_type: user.warning_type,
        },
      });
    },
    HATPYE(type) {
      let mapList = {
        0: "爱牵挂报警墙贴",
        1: "SOS一键报警按钮",
        2: "门磁报警器",
        3: "红外报警器",
        4: "水浸报警器",
        5: "燃气报警器",
        6: "烟雾报警器",
        7: "一氧化碳感应器",
      };
      return mapList[type] || "";
    },
    socketInit() {
      let that = this;
      let loginid = this.auth.id;
      // console.log("loginid001", loginid);

      let ws = new WebSocket(
        "ws://" +
          ws_URL +
          "/smart-care/chat?" +
          loginid +
          "_" +
          that.auth.organization.id
      );

      this.currentLoginId = loginid;

      this.socket = ws;

      //        let date = {
      //          type:'OUT_BED_NOTICE',
      //          login_id:loginid
      //        }
      ws.onopen = function () {
        let data =
          '{"message":"loginid_organ", "loginId":"' +
          that.currentLoginId +
          '", "organId":"' +
          that.auth.organization.id +
          '"}';
        if (ws.readyState == 1) {
          // ws.send(
          //     '{"message":"loginid_organ", "loginId":"' +
          //         that.currentLoginId +
          //         '", "organId":"' +
          //         that.auth.organization.id +
          //         '"}'
          // );
          that.everyTime();

          console.log("头部连接成功01", ws.readyState);
        }
        //          ws.send('连接成功22');

        //添加防超时逻辑
        //          that.checkTimeOut();
      };
      ws.onmessage = function (res) {
        // console.log("res009", res);

        if (!localStorage.getItem("adminToken")) {
          that.socket.close();
        }
        let dat =
          typeof res.data === "object" ? res.data : JSON.parse(res.data);
        let index = 0;
        this.SendData = dat;
        console.log(dat, "我是ws数据");
        bus.$emit("share", this.SendData);

        if (dat.data) {
          if (that.$route.path == "/index/warningDeal" && dat.data.channel) {
            bus.$emit("sleepDemandList");
          }
          if (dat.data.owner) {
            that.ownerData = dat.data.owner;
            console.log(that.ownerData, "that.ownerData");
          } else {
            // that.ownerData = "";
          }
          if (dat.data.type == "HA07X") {
            that.ha07xTerminal = dat.data.terminal;
            that.ha07xTerminal.type = HATPYE(dat.data.terminal.type);
          }
          // 类型：0 爱牵挂报警墙贴，1 SOS一键报警按钮，2 门磁报警器，3 红外报警器，4 水浸报警器，5 燃气报警器，6 烟雾报警器，7 一氧化碳感应器
          function HATPYE(type) {
            let mapList = {
              0: "爱牵挂报警墙贴",
              1: "SOS一键报警按钮",
              2: "门磁报警器",
              3: "红外报警器",
              4: "水浸报警器",
              5: "燃气报警器",
              6: "烟雾报警器",
              7: "一氧化碳感应器",
            };
            return mapList[type] || "";
          }
        }
        that.serverMessage = dat.data
          ? dat.data.message
            ? dat.data.message
            : that.serverMessage
          : "";

        // console.log("serverMessage003", that.serverMessage);
        if (that.serverMessage == "I am OK") {
          // console.log("我已经ok了03");
        }

        /* 
                预警权限层级
                需求:每个层级的头部预警 只能显示对应层级的预警
                做:拿ws返回的数据和登录保存的登录数据判断 层级相同显示 不同过滤
                */
        let flag = false;
        //腕表的推送层级判断
        // //接入大屏退出会重置登录信息的bug
        if (dat.type == "kickOut" && that.$route.path !== "/index/bigScreen") {
          console.log(dat);
          console.log("请重新登录");
          that.$message({
            message: "该用户已在其他地方登陆，请重新登录",
            type: "success",
          });

          let gid =
            that.auth.organization.id == "000000006e90c1f7016ea5a5d95600c2"
              ? "huiming"
              : that.auth.organization.id == "0000000072f21ef4017303b86f0e000a"
              ? "jianggou"
              : that.auth.organization.id == "00000000735c100401735c1802b70001"
              ? "hualing"
              : "";
          // localStorage.removeItem('auth')
          if (gid) {
            that.$router.push({
              name: "login",
              query: {
                gid: gid,
              },
            });
            if (that.$route.path == "/login") {
              location.reload();
            }
            // that.reload()
          } else {
            that.$router.push({
              name: "login",
            });
            if (that.$route.path == "/login") {
              location.reload();
            }
          }
          if (that.oemHome.tag) {
            that.$router.push({
              name: "login",
              query: {
                tag: that.oemHome.tag,
              },
            });
            if (that.$route.path == "/login") {
              location.reload();
            }
          } else {
            that.$router.push({
              name: "login",
            });
            if (that.$route.path == "/login") {
              location.reload();
            }
          }
        }
        if (dat.data) {
          if (that.auth.grade == 1 && dat.data.organization) {
            if (dat.data.organization.id == that.auth.organization.id) {
              flag = true;
            } else {
              flag = false;
            }
          }
          if (that.auth.grade == 2 && dat.data.community) {
            if (
              dat.data.organization.id == that.auth.organization.id &&
              dat.data.community.id == that.auth.community.id
            ) {
              flag = true;
            } else {
              flag = false;
            }
          }
          if (that.auth.grade == 3 && dat.data.sub) {
            if (
              dat.data.organization.id == that.auth.organization.id &&
              dat.data.community.id == that.auth.community.id &&
              dat.data.sub.id == that.auth.sub.id
            ) {
              flag = true;
            } else {
              flag = false;
            }
          }
        }
        //居家 睡眠带设备的预警层级判断
        if (dat.data && dat.data.user) {
          if (that.auth.grade == 1 && dat.data.user.organization_id) {
            if (dat.data.user.organization_id == that.auth.organization.id) {
              flag = true;
            } else {
              flag = false;
            }
          }
          if (that.auth.grade == 2 && dat.data.user.community_id) {
            if (
              dat.data.user.organization_id == that.auth.organization.id &&
              dat.data.user.community_id == that.auth.community.id
            ) {
              flag = true;
            } else {
              flag = false;
            }
          }
          if (that.auth.grade == 3 && dat.data.user.sub_id) {
            if (
              dat.data.user.organization_id == that.auth.organization.id &&
              dat.data.user.community_id == that.auth.community.id &&
              dat.data.user.sub_id == that.auth.sub.id
            ) {
              flag = true;
            } else {
              flag = false;
            }
          }
        }
        console.log(flag);
        if (flag) {
          //睡眠带
          console.log("我进来了");
          if (
            dat.obj_name == "HEARTRATE_NOTICE" ||
            dat.obj_name == "HEARTRATE_NOTICE_HOME" ||
            dat.obj_name == "BREATH_NOTICE" ||
            dat.obj_name == "BREATH_NOTICE_HOME" ||
            dat.obj_name == "OBJECT_IN_BED_NOTICE" ||
            dat.obj_name == "OUT_BED_NOTICE_HOME" ||
            (dat.obj_name == "ONLINE_OFFLINE_NOTICE_HOME" &&
              !dat.data.is_online) ||
            dat.obj_name == "SOS_NOTICE_HOME" ||
            dat.obj_name == "BEDSORE_NOTICE"
          ) {
            that.$store.commit("addSleepData", dat);
            bus.$emit("sleepData", dat);
            console.log(dat.data, "睡眠带预警");
            if (JSON.stringify(that.messagesHome) === "{}") {
              that.messagesHome = [];
              that.messagesHome.unshift({
                user: {
                  name: dat.data.owner.name,
                  id: dat.data.owner.id,
                },
                // sleepId: dat.data.sleep_band_id,
                device_no: dat.data.imei ? dat.data.imei : dat.data.mac,
                warning_type: Number(dat.data.warning_type),
                time_begin: dat.data.time_begin,
              });

              that.warningNumHome++;
            } else {
              that.messagesHome.unshift({
                user: {
                  name: dat.data.owner.name,
                  id: dat.data.owner.id,
                },
                // sleepId: dat.data.sleep_band_id,
                device_no: dat.data.imei ? dat.data.imei : dat.data.mac,
                warning_type: Number(dat.data.warning_type),
                time_begin: dat.data.time_begin,
              });

              that.warningNumHome++;
            }
            //居家设备
          }
          if (
            // [
            //     "SMOKE_WARN_NOTICE",
            //     "PULL_DOWN_WARN_NOTICE",
            //     "ALARM_TEST",
            //     "SOS_NOTICE_HOME_DEVICE",
            //     "WATER_IMMERSION_WARN_NOTICE",
            //     "GAS_WARN_NOTICE",
            //     "DOOR_OPEN_NOTICE",
            // ].includes(dat.obj_name)
            (dat.obj_name == "SMOKE_WARN_NOTICE" &&
              that.auth.role.warning_smoke_enable == 1) ||
            (dat.obj_name == "PULL_DOWN_WARN_NOTICE" &&
              that.auth.role.warning_pull_down_enable == 1) ||
            dat.obj_name == "ALARM_TEST" ||
            (dat.obj_name == "SOS_NOTICE_HOME_DEVICE" &&
              that.auth.role.warning_sos_enable == 1) ||
            (dat.obj_name == "GAS_WARN_NOTICE" &&
              that.auth.role.warning_gas_enable == 1) ||
            (dat.obj_name == "WATER_IMMERSION_WARN_NOTICE" &&
              that.auth.role.warning_water_immersion_enable == 1) ||
            (dat.obj_name == "DOOR_OPEN_NOTICE" &&
              that.auth.role.warning_door_open_enable == 1) ||
            (dat.obj_name == "CO_WARN_NOTICE" &&
              that.auth.role.warning_co_enable == 1)
          ) {
            console.log(dat.data, "居家安全设备预警！！！");
            bus.$emit("homeData", dat);
            that.$store.commit("addHomeData", dat);
            if (JSON.stringify(that.messagesHome) === "{}") {
              that.messagesHome = [];
              that.messagesHome.unshift({
                user: {
                  name: dat.data.owner.name,
                  id: dat.data.owner.id,
                },
                // site: dat.data.fullAreaTypeName,
                warning_type: Number(dat.data.alarmCode),
                time_begin: dat.data.timeBegin,
                Type: dat.data.warningType,
                device_no: dat.data.imei,
              });
              that.warningNumHome++;
            } else {
              that.messagesHome.unshift({
                user: {
                  name: dat.data.owner.name,
                  id: dat.data.owner.id,
                },
                // site: dat.data.fullAreaTypeName,
                warning_type: Number(dat.data.alarmCode),
                time_begin: dat.data.timeBegin,
                Type: dat.data.warningType,
                device_no: dat.data.imei,
              });
              that.warningNumHome++;
            }
          }

          //腕表设备
          if (
            // [
            //     "FENCE_CHANNEL",
            //     "ALERT_REPLY_CHANNEL",
            //     "BLOODOYXGEN_CHANNEL",
            //     "BLOODPRESSURE_CHANNEL",
            //     "FALL_CHANNEL",
            //     "HEARTRATE_CHANNEL",
            //     "WIFIHOME_CHANNEL",
            //     "EXERCISE_HEARTRATE_CHANNEL",
            //     "SOS_CHANNEL",
            //     "TEMPERATURE_CHANNEL",
            // ].includes(dat.data.channel)
            (dat.data.channel == "FENCE_CHANNEL" &&
              that.auth.role.warning_fence_enable == 1) ||
            (dat.data.channel == "ALERT_REPLY_CHANNEL" &&
              that.auth.role.warning_alertreply_enable == 1) ||
            (dat.data.channel == "BLOODOYXGEN_CHANNEL" &&
              that.auth.role.warning_bloodoxygen_enable == 1) ||
            (dat.data.channel == "BLOODPRESSURE_CHANNEL" &&
              that.auth.role.warning_bloodpressure_enable == 1) ||
            (dat.data.channel == "HEARTRATE_CHANNEL" &&
              that.auth.role.warning_heartrate_enable == 1) ||
            (dat.data.channel == "FALL_CHANNEL" &&
              that.auth.role.warning_fall_enable == 1) ||
            (dat.data.channel == "WIFIHOME_CHANNEL" &&
              that.auth.role.warning_wifihome_enable == 1) ||
            (dat.data.channel == "EXERCISE_HEARTRATE_CHANNEL" &&
              that.auth.role.warning_exercise_heartrate_enable == 1) ||
            (dat.data.channel == "SOS_CHANNEL" &&
              that.auth.role.warning_sos_enable == 1) ||
            (dat.data.channel == "TEMPERATURE_CHANNEL" &&
              that.auth.role.warning_temperature_enable == 1) ||
            (dat.data.channel == "WEAR_CHANNEL" &&
              that.auth.role.warning_temperature_enable == 1)
          ) {
            that.$store.commit("addWatchData", dat);
            bus.$emit("watchData", dat);
            if (JSON.stringify(that.messagesHome) === "{}") {
              console.log("我是数组");
              that.messagesHome = [];
              that.messagesHome.unshift({
                user: {
                  name: dat.data.owner.name,
                  id: dat.data.owner.id,
                },
                device_no: dat.data.imei,
                warning_type:
                  dat.data.channel == "FENCE_CHANNEL"
                    ? 123
                    : dat.data.channel == "ALERT_REPLY_CHANNEL"
                    ? 121
                    : dat.data.channel == "BLOODOYXGEN_CHANNEL"
                    ? 129
                    : dat.data.channel == "BLOODPRESSURE_CHANNEL"
                    ? 127
                    : dat.data.channel == "FALL_CHANNEL"
                    ? 125
                    : dat.data.channel == "HEARTRATE_CHANNEL"
                    ? 1
                    : dat.data.channel == "WIFIHOME_CHANNEL"
                    ? 124
                    : dat.data.channel == "EXERCISE_HEARTRATE_CHANNEL"
                    ? 130
                    : dat.data.channel == "TEMPERATURE_CHANNEL"
                    ? 128
                    : dat.data.channel == "WEAR_CHANNEL"
                    ? 131
                    : 122,
                time_begin: dat.data.time_begin,
              });
              that.warningNumHome++;
              console.log(that.warningNumHome);
            } else {
              that.messagesHome.unshift({
                user: {
                  name: dat.data.owner.name,
                  id: dat.data.owner.id,
                },
                device_no: dat.data.imei,
                warning_type:
                  dat.data.channel == "FENCE_CHANNEL"
                    ? 123
                    : dat.data.channel == "ALERT_REPLY_CHANNEL"
                    ? 121
                    : dat.data.channel == "BLOODOYXGEN_CHANNEL"
                    ? 129
                    : dat.data.channel == "BLOODPRESSURE_CHANNEL"
                    ? 127
                    : dat.data.channel == "FALL_CHANNEL"
                    ? 125
                    : dat.data.channel == "HEARTRATE_CHANNEL"
                    ? 1
                    : dat.data.channel == "WIFIHOME_CHANNEL"
                    ? 124
                    : dat.data.channel == "EXERCISE_HEARTRATE_CHANNEL"
                    ? 130
                    : dat.data.channel == "TEMPERATURE_CHANNEL"
                    ? 128
                    : dat.data.channel == "WEAR_CHANNEL"
                    ? 131
                    : 122,
                time_begin: dat.data.time_begin,
              });
              that.warningNumHome++;
              console.log(that.warningNumHome);
            }
          }
        }
        //腕表弹框
        if (dat.data && flag) {
          // 如果是这个类型，是sos紧急呼叫
          if (
            dat.data.channel == "SOS_CHANNEL" &&
            that.auth.role.warning_sos_enable == 1
          ) {
            let queryData = {
              address: dat.data.address,
              city: dat.data.city,
              is_disposed: dat.data.is_disposed,
              time_begin: dat.data.time_begin,
              imei: dat.data.imei,
              lon: dat.data.lon,
              type: dat.data.type,
              lat: dat.data.lat,
              organ_id: dat.data.organization.id,
              user_name: dat.data.owner
                ? dat.data.owner.name
                  ? dat.data.owner.name
                  : ""
                : "",
              user_phone: dat.data.owner
                ? dat.data.owner.mobile_phone
                  ? dat.data.owner.mobile_phone
                  : ""
                : "",
            };

            // let routeData = that.$router.resolve({
            //     name: "detailMap",
            //     query: queryData,
            // });
            // window.open(
            //     routeData.href,
            //     "_blank",
            //     "height=620, width=1100, top=0, left=0, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no"
            // );
            that.SOSemergency = {};
            that.setRuleShow5 = true;
            that.SOSemergency = dat.data;
            that.$nextTick(() => {
              that.getShowMap(queryData);
            });
          } else if (
            dat.data.channel == "TEMPERATURE_CHANNEL" &&
            that.auth.role.warning_temperature_enable == 1
          ) {
            that.temperatureInfo = {};
            console.log("我异常了");
            if (that.auth.role.warning_show_type != 1) {
              that.setRuleShow = true;
              console.log(that.setRuleShow);
            }

            that.temperatureInfo = dat.data;
            console.log("弹窗数据", that.temperatureInfo);
          } else if (
            dat.data.channel == "WIFIHOME_CHANNEL" &&
            that.auth.role.warning_wifihome_enable == 1
          ) {
            that.suspectedToHomeInfo = {};
            if (that.auth.role.warning_show_type != 1) {
              that.setRuleShow2 = true;
            }
            that.suspectedToHomeInfo = dat.data;
            console.log("弹窗数据", that.suspectedToHomeInfo);
          } else if (
            dat.data.channel == "BLOODPRESSURE_CHANNEL" &&
            that.auth.role.warning_bloodpressure_enable == 1
          ) {
            that.dysarteriotony = {};
            if (that.auth.role.warning_show_type != 1) {
              that.setRuleShow3 = true;
            }
            that.dysarteriotony = dat.data;
            console.log("弹窗数据", that.dysarteriotony);
          } else if (
            dat.data.channel == "HEARTRATE_CHANNEL" &&
            that.auth.role.warning_heartrate_enable == 1
          ) {
            that.abnormalities = {};
            if (that.auth.role.warning_show_type != 1) {
              that.setRuleShow4 = true;
            }
            that.abnormalities = dat.data;
            console.log("弹窗数据", that.abnormalities);
          } else if (
            dat.data.channel == "FALL_CHANNEL" &&
            that.auth.role.warning_fall_enable == 1
          ) {
            that.fallWarning = {};
            if (that.auth.role.warning_show_type != 1) {
              that.setRuleShow6 = true;
            }
            that.fallWarning = dat.data;
            console.log("弹窗数据", that.fallWarning);
          } else if (
            dat.data.channel == "FENCE_CHANNEL" &&
            that.auth.role.warning_fence_enable == 1
          ) {
            that.fenceWarning = {};
            console.log("我报警了", 1218);
            if (that.auth.role.warning_show_type != 1) {
              that.setRuleShow7 = true;
              console.log(1225);
            }
            that.fenceWarning = dat.data;
            console.log("弹窗数据", that.fenceWarning);
          } else if (
            dat.data.channel == "ALERT_REPLY_CHANNEL" &&
            that.auth.role.warning_alertreply_enable == 1
          ) {
            that.SpecialRemindInfo = {};
            if (that.auth.role.warning_show_type != 1) {
              that.setRuleShow8 = true;
            }
            that.SpecialRemindInfo = dat.data;
            console.log("弹窗数据", that.SpecialRemindInfo);
          } else if (dat.data.channel == "WEAR_CHANNEL") {
            that.wearAbnormal = {};
            if (
              that.auth.role.warning_show_type != 1 &&
              that.auth.role.warning_wear_enable == 1
            ) {
              that.setRuleShow19 = true;
            }
            that.wearAbnormal = dat.data;
            console.log("弹窗数据", that.wearAbnormal);
          } else if (
            dat.data.channel == "SMOKE_DETECTOR_CHANNEL" &&
            that.auth.role.warning_smoke_enable == 1
          ) {
            that.setRuleShow9 = true;
            that.NtwarningInfo = dat.data;
            console.log(that.NtwarningInfo, "烟感弹窗数据");
          } else if (
            dat.data.channel == "EXERCISE_HEARTRATE_CHANNEL" &&
            that.auth.role.warning_exercise_heartrate_enable == 1
          ) {
            if (that.auth.role.warning_show_type != 1) {
              that.EXSwarningInfo = dat.data;
              that.setRuleShow10 = true;
              console.log(that.EXSwarningInfo, "运动心率弹窗数据");
            }
          } else if (
            dat.data.channel == "BLOODOYXGEN_CHANNEL" &&
            that.auth.role.warning_bloodoxygen_enable == 1
          ) {
            if (that.auth.role.warning_show_type != 1) {
              that.bloodOxygenWarning = dat.data;
              that.setRuleShow12 = true;
            }
          }
        }
        //居家弹框
        if (dat.data && flag) {
          //烟感
          if (
            dat.obj_name == "SMOKE_WARN_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_smoke_enable == 1
          ) {
            that.setRuleShow9 = true;
            that.NtwarningInfo = dat.data;
          }
          //拆除
          if (
            dat.obj_name == "PULL_DOWN_WARN_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_pull_down_enable == 1
          ) {
            that.setRuleShow13 = true;
            that.dismaWarning = dat.data;
          }
          //居家sos
          if (
            dat.obj_name == "SOS_NOTICE_HOME_DEVICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_sos_enable == 1
          ) {
            that.setRuleShow5 = true;
            that.SOSemergency = dat.data;
          }
          //燃气
          if (
            dat.obj_name == "GAS_WARN_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_gas_enable == 1
          ) {
            that.setRuleShow15 = true;
            that.gasWarning = dat.data;
          }
          //水浸
          if (
            dat.obj_name == "WATER_IMMERSION_WARN_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_water_immersion_enable == 1
          ) {
            that.setRuleShow16 = true;
            that.waterWarning = dat.data;
          }
          //开门
          if (
            dat.obj_name == "DOOR_OPEN_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_door_open_enable == 1
          ) {
            that.setRuleShow14 = true;
            that.openWarning = dat.data;
          }
          //没开门
          if (
            dat.obj_name == "DOOR_NOT_OPEN_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_door_not_open_enable == 1
          ) {
            that.setRuleShow29 = true;
            that.NOopenWarning = dat.data;
          }
          //没关门
          if (
            dat.obj_name == "DOOR_NOT_CLOSE_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_door_not_close_enable == 1
          ) {
            that.setRuleShow30 = true;
            that.NOinsWarning = dat.data;
          }
          //一氧化碳
          if (
            dat.obj_name == "CO_WARN_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_co_enable == 1
          ) {
            that.setRuleShow21 = true;
            that.coOneWarning = dat.data;
          }
          //高温
          if (
            dat.obj_name == "HIGH_TEMP_ENV_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_high_temp_env_enable == 1
          ) {
            that.setRuleShow22 = true;
            that.HTeWarning = dat.data;
          }
          //低温
          if (
            dat.obj_name == "LOW_TEMP_ENV_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_low_temp_env_enable == 1
          ) {
            that.setRuleShow23 = true;
            that.LTeWarning = dat.data;
          }
          //高湿
          if (
            dat.obj_name == "HIGH_HUMIDITY_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_high_humidity_enable == 1
          ) {
            that.setRuleShow24 = true;
            that.HHUWarning = dat.data;
          }
          //低湿
          if (
            dat.obj_name == "LOW_HUMIDITY_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_low_humidity_enable == 1
          ) {
            that.setRuleShow25 = true;
            that.LHUWarning = dat.data;
          }
          //自检
          if (
            dat.obj_name == "CHECK_WARN_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_test_fail_enable == 1
          ) {
            that.setRuleShow26 = true;
            that.CHECKWarning = dat.data;
          }
          if (
            dat.obj_name == "HEART_BEAT_WARN_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_heart_beat_enable == 1
          ) {
            that.setRuleShow27 = true;
            that.HeartBeaWarning = dat.data;
          }
          if (
            dat.obj_name == "LOW_POWER_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_low_power_enable == 1
          ) {
            that.setRuleShow28 = true;
            that.LowPowerWarning = dat.data;
          }
        }
        //睡眠带弹框
        if (flag) {
          console.log(1);
          //心率异常
          if (
            dat.obj_name == "HEARTRATE_NOTICE_HOME" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_heartrate_enable == 1
          ) {
            that.setRuleShow4 = true;
            that.abnormalities = dat.data;
          }
          //呼吸异常
          if (
            dat.obj_name == "BREATH_NOTICE_HOME" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_breath_enable == 1
          ) {
            that.setRuleShow17 = true;
            that.breathWarning = dat.data;
            console.log(that.breathWarning, 1636);
          }
          //离床
          if (
            dat.obj_name == "OUT_BED_NOTICE_HOME" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_out_bed_enable == 1
          ) {
            that.setRuleShow11 = true;
            that.outBedWarning = dat.data;
          }
          //重物
          if (
            dat.obj_name == "OBJECT_IN_BED_NOTICE" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_object_in_bed_enable == 1
          ) {
            that.setRuleShow20 = true;
            that.outBedWarning = dat.data;
          }
          //睡眠带sos
          if (
            dat.obj_name == "SOS_NOTICE_HOME" &&
            that.auth.role.warning_show_type != 1 &&
            that.auth.role.warning_sos_enable == 1
          ) {
            that.setRuleShow5 = true;
            that.SOSemergency = dat.data;
          }
          //睡眠带设备异常
          if (
            dat.obj_name == "ONLINE_OFFLINE_NOTICE_HOME" &&
            that.auth.role.warning_show_type != 1 &&
            !dat.data.is_online
          ) {
            that.setRuleShow18 = true;
            that.EquipmentAbnormal = dat.data;
          }
        }

        // 机构 ， 当点击预警处理好之后实施刷新预警数据
        if (dat.obj_name == "WARNING_HAS_DISPOSED_NOTICE") {
          that.headDetails();
        }
        // 居家 ， 当点击预警处理好之后实施刷新预警数据
        if (dat.obj_name == "WARNING_HAS_DISPOSED_NOTICE_HOME") {
          that.getHomeOld();
        }
        if (dat.obj_name == "SEEK_HELP_NOTICE") {
          console.log("我在求助", dat.data.dispose_employee.name);
          that.warningNum++;
          that.helpInformations.push(dat.data);
        }
        if (dat.data && flag) {
          let codeIns = dat.data.warningType;
          let newCodeWARNING = [2901];
          that.newInfoBoxTitle = that.$utils.codePYE(codeIns);
          if (newCodeWARNING.includes(codeIns) && codeIns) {
            that.newInfoBoxShow = true;
            console.log("新的弹窗信息", dat.data);
            that.newInfoBox = dat.data;
          }
        }

        //ws每次推送数据处理
        // that.getHomeOld();
        // 判断popup属性是否存在且为true
        if (dat.data.hasOwnProperty("popup") && dat.data.popup === true) {
           console.log("popup属性存在且为true");
           that.getHomeOld();
        } 
      };
      ws.onclose = function () {
        if (!that.closeStatus) {
          setTimeout(function () {
            that.socket.close();
            console.log("socket重启", that.socket);
            that.socketInit();
          }, 30000);
        }
        //断线重连
      };
      ws.onerror = function () {
        that.$notify({
          title: "提示",
          message: "WebSocket链接失败,请检查网络是否正常！",
        });
        if (!that.closeStatus) {
          // setTimeout(function () {
          //   that.socket.close();
          //   that.socketInit();
          // }, 30000);
          //  that.socketInit();
          // const timer = setTimeout(() => {
          //   that.socket.close();
          //   that.socketInit();
          // }, 120000); // 60秒后触发定时器
        }
      };
    },

    getHomeOld() {
      let that = this;
      console.log(this.auth);
      let data = {
        // grade: this.auth.grade,
        organ_id: this.auth.organization.id,
        community_id: this.auth.community.id ? this.auth.community.id : "",
        sub_id: this.auth.sub ? this.auth.sub.id : "",
        // pension_mode: 2,
        page: 1,
        rows_per_page: 10,
      };

      get(api_listWarningNotice, data, (res) => {
        if (res.success) {
          console.log(res);
          this.messagesHome = res.data;
          this.warningNumHome = res.total;
          // for (let i = 0; i < res.data.length; i++) {
          //     if (res.data[i].mac) { //睡眠带
          //         // console.log(res.data[i]);
          //         that.messagesHome.push({
          //             name: res.data[i].user.name,
          //             userId: res.data[i].user.id,
          //             pensionM: res.data[i].user.pension_mode,
          //             sleepId: res.data[i].sleep_band_id,
          //             mac: res.data[i].mac,
          //             isWarningType:
          //                 res.data[i].warning_type == 1
          //                     ? "心率异常"
          //                     : res.data[i].warning_type == 2
          //                     ? "呼吸异常"
          //                     : res.data[i].warning_type == 3
          //                     ? "离床异常"
          //                     : res.data[i].warning_type == 4
          //                     ? "设备异常"
          //                     : res.data[i].warning_type == 122
          //                     ? "SOS异常"
          //                     : "",
          //             timeBegin: res.data[i].time_begin,
          //         });
          //     } else if (res.data[i].imei) {
          //         that.messagesHome.push({
          //             Type: res.data[i].warning_type,
          //             isWarningType: res.data[i].warning_type,
          //             name: res.data[i].house_name,
          //             site: res.data[i].full_area_type_name,
          //             timeBegin: res.data[i].time_begin,
          //         });
          //     }
          // }
          bus.$emit("warningNumHome", that.warningNumHome);
          that.$store.commit("addNumHome", that.warningNumHome);
          that.isWarningPromptHome = res.data.length ? 2 : 1;
        }
      });
    },
    //机构养老
    headDetails() {
      let that = this;

      // console.log("123456789", this.switchMode);

      let dataOne = {
        grade: this.auth.grade,
        organ_id: this.auth.organization.id,
        community_id: this.auth.community_id,
        pension_mode: 1,
        page: 1,
        rows_per_page: 5,
      };
      get(api_listWarningNotice, dataOne, (res) => {
        if (res.success) {
          this.messages = [];

          //            this.warningNum = res.total ;
          this.warningNum = res.total;

          for (let i = 0; i < res.data.length; i++) {
            that.messages.push({
              name: res.data[i].user.name,
              userId: res.data[i].user.id,
              pensionM: res.data[i].user.pension_mode,
              sleepId: res.data[i].sleep_band_id,
              mac: res.data[i].mac,
              isWarningType:
                res.data[i].warning_type == 1
                  ? "心率异常"
                  : res.data[i].warning_type == 2
                  ? "呼吸异常"
                  : res.data[i].warning_type == 3
                  ? "离床异常"
                  : res.data[i].warning_type == 4
                  ? "设备异常"
                  : res.data[i].warning_type == 10
                  ? "重物预警"
                  : res.data[i].warning_type == 122
                  ? "SOS异常"
                  : "",
              timeBegin: res.data[i].time_begin,
            });
          }

          that.isWarningPrompt = res.data.length ? 2 : 1;

          // console.log("预警信息", that.messages);
        }
      });
    },
    creteTable(data) {
      let that = this;

      let arr = [];

      for (let i = 0; i < data.length; i++) {
        arr.push({
          floor: data[i].floor.floor_no,
          room: data[i].room.room_no,
          bed: data[i].bed.bed_no,
          name: data[i].user.name,
          bedId: data[i].bed.id,
          userId: data[i].user.id,
          sleepId: data[i].sleep_band_id,
          mac: data[i].mac,
          isWarningType:
            data[i].warning_type == 1
              ? "心率异常"
              : data[i].warning_type == 2
              ? "呼吸异常"
              : data[i].warning_type == 3
              ? "离床异常"
              : res.data[i].warning_type == 4
              ? "设备异常"
              : res.data[i].warning_type == 10
              ? "重物异常"
              : data[i].warning_type == 122
              ? "SOS异常"
              : "",
          timeBegin: data[i].time_begin,
        });
      }
    },
    autoPlay() {},
    getHelp(item, index) {
      // console.log('点击我在求助',item,index);
      this.helpInformations.splice(index, 1);
      this.warningNum--;
    },
    // toRemind() {
    //     let data = {
    //         grade: this.auth.grade,
    //         organ_id: this.auth.organization.id,
    //         community_id: this.auth.community_id,
    //     };
    //     post(api_listToDoList, data, (res) => {
    //         if (res.success) {
    //             // console.log('resdata66', res.data);
    //             this.backlogRemind = res.data;
    //         }
    //     });
    // },
    //自动刷新待办提醒
    //      selfMotionRemeind() {
    //        let data = {
    //          grade: this.auth.grade,
    //          organ_id: this.auth.organ_id,
    //          community_id: this.auth.community_id
    //        };
    //        post(api_timingGetToDo ,data ,res=> {
    //            if(res.success) {
    //                console.log('自动刷新待办提醒', res);
    //                this.remendTotal = res.total ? res.total : this.remendTotal ;
    //            }
    //        })
    //
    //      },
    memorandum() {
      //        let data = {
      //          operator_id:this.auth.id,
      //          content: this.memoTextarea,
      //        };
      //        post(api_addMemorandum,data, res=> {
      //            if(res.success) {
      //              this.visible = false ;
      //              console.log('备忘录', res.data);
      //              this.$message({
      //                message: '添加成功',
      //                type: 'success'
      //              });
      //            }
      //        })
      if (this.amendOrSave == "保存") {
        let data = {
          operator_id: this.auth.id,
          content: this.memoTextarea,
        };
        post(api_addMemorandum, data, (res) => {
          if (res.success) {
            this.visible = false;
            this.amendOrSave = "修改";
            this.isDisabled = true;
            console.log("备忘录", res.data);
            this.$message({
              message: "修改成功",
              type: "success",
            });
          }
        });
      }
      this.amendOrSave = "保存";
      this.isDisabled = false;
    },
    readMemo() {
      post(api_getMemorandum, { operator_id: this.auth.id }, (res) => {
        if (res.success) {
          // console.log("备忘录读取成功", res.data);
          this.memoTextarea = res.data.content;
        }
      });
    },
    everyTime() {
      let that = this;
      clearInterval(that.everyTimeOuter);
      that.everyTimeOuter = setInterval(function () {
        that.serverMessage = "";
        console.log("打印socket", that.socket.readyState);
        if (that.socket) {
          if (that.socket.readyState == 1) {
            that.socket.send(
              '{"message":"are you OK?", "loginId":"' +
                that.currentLoginId +
                "_" +
                that.auth.organization.id +
                '"}'
            );
          }
        }
        //            that.socket.send();
        //            that.outOnce = 1 ;
      }, 120000);
    },
    warningHide() {
      // this.messages = [] ;
      // this.isWarningPrompt = 1 ;
      // this.warningNum = 0 ;
      // this.helpInformation = {} ;
      // this.helpInformations = [] ;
    },
    // allDeal(index) {
    //     console.log("backlogRemind", this.backlogRemind[index].id);
    //     post(
    //         api_completeToDoList,
    //         { to_do_id: this.backlogRemind[index].id },
    //         (res) => {
    //             if (res.success) {
    //                 console.log("已处理");
    //                 this.$message({
    //                     message: "已处理",
    //                     type: "success",
    //                 });
    //             }
    //             this.toRemind();
    //         }
    //     );
    // },
    // toRemindOne() {
    //     this.remendTotal = 0;
    // },

    //切换模式
    changeMode() {
      console.log(this.switchMode);

      let data = {
        role_id: this.auth.role_id,
        pension_mode: this.switchMode,
      };

      post(api_setPensionMode, data, (res) => {
        if (res.success) {
          console.log("养老切换模式", res);

          bus.$emit("toggleMode", this.switchMode);

          localStorage.setItem("toggleM", this.switchMode);
          // this.$store.commit("toggleModeAll",this.switchMode)

          // console.log('养老切换模式02',this.$store.state.login.modeAll)

          //局部刷新
          let currentPath = this.$route.path;
          if (this.switchMode == 1 && currentPath == "/index/homeMG") {
            currentPath = "/index/bedMG";
          } else if (this.switchMode == 2 && currentPath == "/index/bedMG") {
            currentPath = "/index/homeMG";
          }

          this.$router.push({
            path: currentPath,
            query: this.$route.query,
          });
          bus.$emit("aacc");

          // window.location.reload();
        }
      });
    },
    handleCommand(command) {
      console.log("command", command);
      this.switchMode = command;
      if (command == 1) {
        this.menuName = "机构养老";
      } else {
        this.menuName = "居家养老";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '../libs/minxin.styl';

.headers {
  width: 100%;
  height: 100%;
  color: #fff;
  display: flex;
  align-items: center;
  position: relative;

  .right-all {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .left-box {
      display: flex;

      .l-b-h {
        font-size: 20px;
        margin-left: 20px;
        letter-spacing: 0.02rem;
      }

      .confirm-btn {
        margin-left: 10px;
      }

      .change-pattern {
        background: #fff;
        height: 30px;
        display: flex;
        align-items: center;
        margin-left: 0.5rem;
      }
    }
  }

  .h-logo {
    width: 200px;
    height: 100%;
    display: flex;
    cursor: pointer;
    justify-content: space-between;
    align-items: center;

    .h-l {
      background: url('../assets/images/logo3.png') center center / 100% no-repeat;
      width: 1.35rem;
      height: 100%;
    }

    .h-two {
      background: url('../assets/images/logo02.png') center center / 100% no-repeat;
      width: 1.35rem;
      height: 100%;
    }

    .h-three {
      background: url('../assets/images/logo04.png') center center / 100% no-repeat;
      width: 3rem;
      height: 100%;
    }

    .h-four {
      background: url('../assets/images/logo05.png') center center / 100% no-repeat;
      width: 2rem;
      height: 100%;
    }

    .h-five {
      background: url('../assets/images/logo06.png') center center / 100% no-repeat;
      width: 92%;
      height: 100%;
    }

    .h-eight {
      background: url('../assets/images/logo08.png') center center / 100% no-repeat;
      width: 92%;
      height: 100%;
    }
  }
}

.h-nine {
  background: url('../assets/images/logo09.png') center center / 100% no-repeat;
  width: 1.35em;
  height: 100%;
}

.u-i-left {
  margin-right: 10px;
  width: 150px;
  text-align: right;
}

.right-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .r-item {
    display: flex;
    flex-flow: column;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    fontSize(0.16);
    margin-left: 0.7rem;
    position: relative;

    .el-badge {
      margin-top: 0.1rem;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .r-txt {
      line-height: 1.9;
    }

    .no-warning {
      background-color: #717071;
      border: 1px solid #fff;
    }

    .warning {
      background-color: #f73f4c;
    }
  }

  .r-warning {
    margin-top: 0.3rem;

    .r-warning-remend {
      margin-top: -0.3rem;
    }

    .warning-icon {
      width: 0.38rem;
      height: 0.36rem;
      background-image: url('../assets/images/header-icon1.png');
      background-size: 0.76rem;
      background-position: 0 0;
      background-repeat: no-repeat;
    }

    .warining-icon-active {
      background-image: url('../assets/images/header-icon1.gif');
      background-size: 0.4rem;
    }
  }

  .r-undo {
    .r-undo-badgeBox {
      display: flex;
      flex-flow: column;
      cursor: pointer;
      justify-content: center;
      align-items: center;
      position: relative;
      margin-top: 0.1rem;

      .item {
        position: absolute;
        right: 0.05rem;
        bottom: 0.1rem;
      }
    }

    .undo-icon {
      width: 0.34rem;
      height: 0.34rem;
      background-image: url('../assets/images/header-icon4.png');
      background-size: 0.34rem;
      background-position: 0 0;
      background-repeat: no-repeat;
    }
  }

  .r-memo {
    .r-memo-badgeBox {
      display: flex;
      flex-flow: column;
      cursor: pointer;
      justify-content: center;
      align-items: center;
    }

    .memo-icon {
      width: 0.29rem;
      height: 0.34rem;
      background-image: url('../assets/images/header-icon2.png');
      background-size: 0.29rem;
      background-position: 0 0;
      background-repeat: no-repeat;
    }
  }

  .r-message {
    .message-icon {
      width: 0.44rem;
      height: 0.38rem;
      background-image: url('../assets/images/header-icon3.png');
      background-size: 0.44rem;
      background-position: 0 0;
      background-repeat: no-repeat;
    }
  }

  .r-user {
    padding: 0 0.35rem;
    height: 1rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    border-left: 1px solid #6b6b6b;
    border-right: 1px solid #6b6b6b;
    margin-left: 0.35rem;
    position: relative;
    cursor: pointer;

    &:hover {
      .r-password-tap {
        height: 0.75rem;
      }
    }

    .r-user-head {
      width: 36px;
      height: 36px;
      overflow: hidden;
      border-radius: 50%;
      border: 1px solid #fff;
      background: url('../assets/images/gwl.jpg') center center / 100% no-repeat;
      margin-right: 0.15rem;
    }

    .r-user-name {
      color: #fff;
      fontSize(0.16);
    }

    .r-password-tap {
      position: absolute;
      left: 0;
      transition: all 0.3s;
      top: 0.81rem;
      width: 100%;
      cursor: pointer;
      overflow: hidden;
      height: 0rem;
      font-size: 14px;
      background: #4b4b4b;
      z-index: 10;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
      color: #ffffff;

      .r-p-list {
        width: 100%;
        height: 0.3rem;
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
    }
  }

  .r-out {
    fontSize(0.16);
    color: #fff;
    padding: 0 0.35rem;
    cursor: pointer;
  }
}

.l-o-j-tit {
  width: 100%;
  height: 0.7rem;
  font-size: 16px;
  color: #fff;
  text-align: center;
  background: $color2;
  line-height: 0.7rem;
}

.l-o-j-content {
  width: 100%;
  box-sizing: border-box;
  padding: 0.4rem 0.5rem;

  .l-box {
    display: flex;
    flex-flow: column;
  }

  .contbox-default-content {
    display: flex;
    flex: 1;
    width: 100%;
    align-items: flex-end;
    justify-content: flex-start;

    .c-d-c-tit {
      white-space: nowrap;
    }
  }

  .l-o-j-submit {
    width: 100%;
    font-size: 16px;
    text-align: center;
    padding: 0;
    height: 50px;
    line-height: 50px;
    color: #fff;
    background: $color2;
    border-radius: 2px;
    cursor: pointer;
    margin-top: 60px;
  }
}

.no-warning-list {
  padding: 0.15rem;
  text-align: center;
}

.select-old {
  margin-top: -0.2rem !important;
}

.dropA {
  width: 100px;

  .el-dropdown-link {
    cursor: pointer;
  }
}

.service-title {
  position: absolute;
  top: -11px;
  color: #fff;
  text-align: center;
}

.order-data {
  .user-i-name {
    display: flex;
    align-items: center;
    // margin: 35px 10px;
    line-height: 0.4rem;
  }

  .u-i-left {
    margin-right: 10px;
    width: 150px;
    text-align: right;
  }

  .new-save {
    width: 100px;
    height: 50px;
    line-height: 23px;
    background: #ff7624;
    text-align: center;
    margin: 40px auto 0;
    padding: 15px 0;
    border-radius: 25px;
    color: #fff;
    cursor: pointer;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue